
// import React, { useState, useEffect } from 'react';
// import {
//     Box,
//     Typography,
//     TextField,
//     Button,
//     CircularProgress,
// } from '@mui/material';
// import { useLocation, useNavigate } from 'react-router-dom';
// import HtmlEditor from '../../Common/HtmlEditor';
// import axios from 'axios';
// import apiUrl from '../../Config';

// const AddEditFaqs = () => {
//     const { state } = useLocation();
//     const navigate = useNavigate();
//     const editingFaq = state?.faq;

//     const [question, setQuestion] = useState('');
//     const [answer, setAnswer] = useState('');
//     const [sequenceOrder, setSequenceOrder] = useState(1);

//     const [loading, setLoading] = useState(false)
//     const [error, setError] = useState("")

//     useEffect(() => {
//         if (editingFaq) {
//             setQuestion(editingFaq.question);
//             setAnswer(editingFaq.answer);
//             setSequenceOrder(editingFaq.sequenceOrder);
//         }
//     }, [editingFaq]);

//     const handleSubmit = async (e) => {
//         e.preventDefault();
//         setLoading(true)
//         const payload = { question, answer, sequenceOrder };

//         try {
//             if (editingFaq) {
//                 await axios.put(`${apiUrl}/faqs/updatefaq/${editingFaq.id}`, payload);
//             } else {
//                 await axios.post(`${apiUrl}/faqs/createfaq`, payload);
//             }
//             navigate('/display-faqs');
//         } catch (error) {
//             console.log('Submit error:', error);
//         } finally {
//             setLoading(false)
//         }
//     };

//     return (
//         <Box p={{ sm: 2, xs: 2, md: 4, lg: 4 }} >
//             <Typography variant="h4" mb={3} textAlign="left">
//                 {editingFaq ? 'Edit FAQ' : 'Add FAQ'}
//             </Typography>

//             <Box component="form" sx={{ maxWidth: 500, border: '1px solid lightgrey', borderRadius: '5px', padding: 2 }} onSubmit={handleSubmit}>
//                 <TextField
//                     label="Sequence Order"
//                     type="number"
//                     fullWidth
//                     required
//                     size="small"
//                     value={sequenceOrder}
//                     onChange={(e) => setSequenceOrder(parseInt(e.target.value))}
//                     sx={{ mb: 2 }}
//                 />
//                 <TextField
//                     label="Question"
//                     fullWidth
//                     required
//                     size="small"
//                     value={question}
//                     onChange={(e) => setQuestion(e.target.value)}
//                     sx={{ mb: 2 }}
//                 />
//                 <Typography variant="subtitle1" mb={1}>Answer</Typography>
//                 <HtmlEditor value={answer} onChange={(content) => setAnswer(content)} />

//                 <Box mt={3} display="flex" justifyContent="right" gap={3}>
//                     <Button variant="outlined" color="primary" onClick={() => navigate('/display-faqs')}>
//                         Cancel
//                     </Button>
//                     {/* <Button type="submit" variant="contained">
//                         {editingFaq ? 'Update FAQ' : 'Create FAQ'}
//                     </Button> */}
//                     <Button
//                         type="submit"
//                         variant="contained"
//                         disabled={loading}
//                         startIcon={loading ? <CircularProgress size={20} color="inherit" /> : null}
//                     >
//                         {loading ? (editingFaq ? 'Updating...' : 'Creating...') : (editingFaq ? 'Update FAQ' : 'Create FAQ')}
//                     </Button>
//                 </Box>
//             </Box>
//         </Box>
//     );
// };

// export default AddEditFaqs;

import React, { useState, useEffect } from 'react';
import {
    Box,
    Typography,
    TextField,
    Button,
    CircularProgress,
} from '@mui/material';
import { useLocation, useNavigate } from 'react-router-dom';
import HtmlEditor from '../../Common/HtmlEditor';
import axios from 'axios';
import apiUrl from '../../Config';
import { toast } from 'react-toastify';

const AddEditFaqs = () => {
    const { state } = useLocation();
    const navigate = useNavigate();
    const editingFaq = state?.faq;

    const [question, setQuestion] = useState('');
    const [answer, setAnswer] = useState('');
    const [sequenceOrder, setSequenceOrder] = useState(1);

    const [loading, setLoading] = useState(false);
    const [errors, setErrors] = useState({
        question: '',
        answer: '',
        sequenceOrder: '',
        submit: '',
    });

    useEffect(() => {
        if (editingFaq) {
            setQuestion(editingFaq.question);
            setAnswer(editingFaq.answer);
            setSequenceOrder(editingFaq.sequenceOrder);
        }
    }, [editingFaq]);

    const validate = () => {
        let valid = true;
        const newErrors = { question: '', answer: '', sequenceOrder: '', submit: '' };

        if (!question.trim()) {
            newErrors.question = 'Question is required';
            valid = false;
        }
        if (!answer || answer.trim() === '' || answer === '<p><br></p>') {
            newErrors.answer = 'Answer is required';
            valid = false;
        }
        if (!sequenceOrder || isNaN(sequenceOrder) || sequenceOrder < 1) {
            newErrors.sequenceOrder = 'Sequence Order must be a positive number';
            valid = false;
        }

        setErrors(newErrors);
        return valid;
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (!validate()) {
            return;
        }

        setLoading(true);
        setErrors((prev) => ({ ...prev, submit: '' }));

        const payload = { question, answer, sequenceOrder };

        try {
            if (editingFaq) {
                await axios.put(`${apiUrl}/faqs/updatefaq/${editingFaq.id}`, payload);
                toast.success('FAQ updated successfully');
            } else {
                await axios.post(`${apiUrl}/faqs/createfaq`, payload);
                toast.success('FAQ created successfully');
            }
            navigate('/display-faqs');
        } catch (error) {
            console.log('Submit error:', error);
            const message = error?.response?.data?.message || 'Failed to submit FAQ';
            setErrors((prev) => ({ ...prev, submit: message }));
            toast.error(message);
        } finally {
            setLoading(false);
        }
    };

    return (
        <Box p={{ sm: 2, xs: 2, md: 4, lg: 4 }}>
            <Typography variant="h4" mb={3} textAlign="left">
                {editingFaq ? 'Edit FAQ' : 'Add FAQ'}
            </Typography>

            <Box
                component="form"
                sx={{
                    maxWidth: 500,
                    border: '1px solid lightgrey',
                    borderRadius: '5px',
                    padding: 2,
                }}
                onSubmit={handleSubmit}
                noValidate
            >
                <TextField
                    label="Sequence Order"
                    type="number"
                    fullWidth
                    required
                    size="small"
                    value={sequenceOrder}
                    onChange={(e) => setSequenceOrder(parseInt(e.target.value, 10))}
                    error={!!errors.sequenceOrder}
                    helperText={errors.sequenceOrder}
                    sx={{ mb: 2 }}
                />
                <TextField
                    label="Question"
                    fullWidth
                    required
                    size="small"
                    value={question}
                    onChange={(e) => setQuestion(e.target.value)}
                    error={!!errors.question}
                    helperText={errors.question}
                    sx={{ mb: 2 }}
                />
                <Typography variant="subtitle1" mb={1}>
                    Answer
                </Typography>
                <HtmlEditor
                    value={answer}
                    onChange={(content) => setAnswer(content)}
                />
                {errors.answer && (
                    <Typography variant="caption" color="error" sx={{ mt: 0.5, mb: 2 }}>
                        {errors.answer}
                    </Typography>
                )}

                {errors.submit && (
                    <Typography variant="body2" color="error" sx={{ mb: 2 }}>
                        {errors.submit}
                    </Typography>
                )}

                <Box mt={3} display="flex" justifyContent="right" gap={3}>
                    <Button
                        variant="outlined"
                        color="primary"
                        onClick={() => navigate('/display-faqs')}
                        disabled={loading}
                    >
                        Cancel
                    </Button>
                    <Button
                        type="submit"
                        variant="contained"
                        disabled={loading}
                        startIcon={
                            loading ? <CircularProgress size={20} color="inherit" /> : null
                        }
                    >
                        {loading
                            ? editingFaq
                                ? 'Updating...'
                                : 'Creating...'
                            : editingFaq
                            ? 'Update FAQ'
                            : 'Create FAQ'}
                    </Button>
                </Box>
            </Box>
        </Box>
    );
};

export default AddEditFaqs;
